import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CartService } from "../../../services/cart/cart.service";
import { ShoppingCart } from "../../../services/cart/shopping-cart";

@Component({
    selector: "app-shopping-cart-icon",
    templateUrl: "./shopping-cart-icon.component.html",
    styleUrls: ["./shopping-cart-icon.component.scss"],
    standalone: false
})
export class ShoppingCartIconComponent implements OnInit {
  private cartService = inject(CartService);
  private readonly destroyRef = inject(DestroyRef);

  @Output() ToggleShoppingCart: EventEmitter<void> = new EventEmitter<void>();
  @Input() cartClass: string;
  shoppingCartData: ShoppingCart = new ShoppingCart();

  ngOnInit(): void {
    this.cartService.getCart().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((r) => {
      this.shoppingCartData = r;
    });
  }

  getTotalShoppingCartItems(): number {
    return this.shoppingCartData.items.reduce((a, b) => a + b.Quantity, 0);
  }

  toggleShoppingCartHandler() {
    this.ToggleShoppingCart.emit();
  }
}
